<template lang="pug">
.template-diff-input-item-component
  .section-and-group(v-if="isSection(beforeValue) || isGroup(beforeValue)" :class="_margin")
    //- type: section
    .template-item.d-flex.flex-column(v-if="isSection(beforeValue)")
      .d-flex.flex-row
        .section-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .section-text(v-if="beforeValue.text") {{ beforeValue.text }}
      .section-text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      .mb-2
      .section-items
        .section-item(v-for="(property, index) in beforeValue.properties" :key="property.id")
          WaiterTemplateDiffInputItem(v-model="value.properties[index]" :beforeValue="beforeValue.properties[index]"
            :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")

    //- type: group
    .template-group-item.d-flex.flex-column.mb-3(v-if="isGroup(beforeValue)")
      .d-flex.flex-row
        .section-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .section-text(v-if="beforeValue.text") {{ beforeValue.text }}
      .section-text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      .mb-2
      .group-items(v-for="(property, index) in getBeforePropertiesOfGroup(beforeValue, value)" :key="beforeValue.id + '-' + index")
        .group-item.pt-2.pb-2.mb-2
          .group-child-item(v-for="(childProperty, childIndex) in property" :key="beforeValue.id + '-' + index + '-' + childIndex")
            WaiterTemplateDiffInputItem(v-model="value.properties[index][childIndex]"
              :beforeValue="getBeforePropertiesOfGroup(beforeValue, value)[index][childIndex]"
              :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")

  .template-items(v-else :class="{ 'facility-only': beforeValue.displayToUser == false, 'diff-border': showAfterValue(value, beforeValue) }").mr-3.mb-3.ml-3
    //- type: text
    .template-item.d-flex.flex-column.mb-2(v-if="isText(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .item-text.d-flex.flex-row
        .text-prefix.mr-2(v-if="beforeValue.prefix") {{ beforeValue.prefix }}
        span.warning-message(v-if="!beforeValue.answer") 未入力
        span(v-else) {{ beforeValue.answer }}
        .text-suffix.ml-2 {{ beforeValue.suffix }}
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        .d-flex.flex-row.align-items-center(v-if="value.prefix || value.suffix")
          .text-prefix.mr-2(v-if="value.prefix") {{ value.prefix }}
          b-form-input(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :min="value.min" :max="value.max"
            :minlength="value.minlength" :maxlength="value.maxlength" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
            v-validate="createValidateRules(value)" data-vv-as="本項目" :style="getTextStyle(value)")
          .text-suffix.ml-2 {{ value.suffix }}
        div(v-else)
          b-form-input(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :min="value.min" :max="value.max"
            :minlength="value.minlength" :maxlength="value.maxlength" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
            v-validate="createValidateRules(value)" data-vv-as="本項目" :style="getTextStyle(value)")
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}

    //- type: radio
    .template-item.d-flex.flex-column.mb-2(v-if="isRadio(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .radio-item
        span.warning-message(v-if="!beforeValue.answer") 未入力
        span(v-else) {{ getRadioText(beforeValue) }}
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        template(v-if="value.align == 'vertical'")
          template(v-for="(option, index) in value.options")
            .radio-item(v-if="index == 0")
              b-form-radio(v-model="value.answer" :name="value.id" :value="option.value" v-validate="createValidateRules(value)" data-vv-as="本項目") {{ option.text }}
            .radio-item(v-else)
              b-form-radio(v-model="value.answer" :name="value.id" :value="option.value") {{ option.text }}
        template(v-else)
          b-form-radio-group(:id="value.id" v-model="value.answer" :name="value.id" :options="value.options"
            v-validate="createValidateRules(value)" data-vv-as="本項目")
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}

    //- type: radioGroup
    .template-item-radio-group.d-flex.flex-column.mb-2(v-if="isRadioGroup(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      .radio-item
        span.warning-message(v-if="!value.answer") 未入力
      //- before value
      .radio-items(v-for="(property, index) in beforeValue.properties")
        template(v-if="beforeValue.answer == property.option.value")
          .radio-item
            span {{ property.option.text }}
          .radio-properties.pt-2.mt-2(v-if="property.properties && 0 < property.properties.length")
            .group-child-item(v-for="(childProperty, childIndex) in property.properties")
              WaiterTemplateDiffInputItem(v-model="value.properties[index].properties[childIndex]"
                :beforeValue="beforeValue.properties[index].properties[childIndex]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        .radio-items.mb-2(v-for="(property, index) in value.properties" :key="value.id + '-' + index")
          .radio-item(v-if="index == 0")
            b-form-radio(v-model="value.answer" :name="value.id" :value="property.option.value" v-validate="createValidateRules(value)" data-vv-as="本項目") {{ property.option.text }}
          .radio-item(v-else)
            b-form-radio(v-model="value.answer" :name="value.id" :value="property.option.value") {{ property.option.text }}
          .radio-properties.pt-2.mt-2(v-if="property.properties && 0 < property.properties.length && value.answer == property.option.value")
            .group-child-item(v-for="(childProperty, childIndex) in property.properties" :key="value.id + '-' + index + '-' + childIndex")
              WaiterTemplateDiffInputItem(v-model="value.properties[index].properties[childIndex]"
                :beforeValue="beforeValue.properties[index].properties[childIndex]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}

    //- type: select
    .template-item-select.d-flex.flex-column.mb-2(v-if="isSelect(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .select-item
        span.warning-message(v-if="!beforeValue.answer") 未入力
        span(v-else) {{ getSelectText(beforeValue) }}
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        b-form-select.d-flex.flex-column(:id="value.id" v-model="value.answer" :name="value.id" :options="createSelectOptions(value.options)"
          :multiple="value.multiple" v-validate="createValidateRules(value)" data-vv-as="本項目")
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}

    //- type: checkbox
    .template-item-checkbox.d-flex.flex-column.mb-2(v-if="isCheckbox(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .d-flex.flex-row.align-items-center
        img.checkbox.mr-1(v-if="beforeValue.answer == null" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="beforeValue.answer == false" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="beforeValue.answer == true" src="@/assets/login-checkbox-on.png")
        span {{ beforeValue.question }}
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        b-form-checkbox(:id="value.id" v-model="value.answer" :name="value.id" :value="true" :unchecked-value="false"
          v-validate="createValidateRules(value)" data-vv-as="本項目") {{ value.question }}
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}

    //- type: siwtch checkbox
    .template-item-switch-checkbox.d-flex.flex-column(v-if="isSwitchCheckbox(value)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .d-flex.flex-row.align-items-center
        img.checkbox.mr-1(v-if="beforeValue.answer == null" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="beforeValue.answer == false" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="beforeValue.answer == true" src="@/assets/login-checkbox-on.png")
        span {{ beforeValue.question }}

      .checkbox-items.mt-2.mb-2(v-if="value.showRule == value.answer || (value.showRule == false && value.answer == null)")
        .checkbox-property.pt-2.mt-2(v-for="(property, index) in value.properties" :key="value.id + '-' + index")
          WaiterTemplateDiffInputItem(v-model="value.properties[index]" :beforeValue="beforeValue.properties[index]"
            :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        b-form-checkbox(:id="value.id" v-model="value.answer" :name="value.id" :value="true" :unchecked-value="false"
          v-validate="createValidateRules(value)" data-vv-as="本項目") {{ value.question }}
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}

    //- type: multipleCheckbox
    .template-item-checkbox.d-flex.flex-column.mb-2(v-if="isMultipleCheckbox(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .d-flex.flex-row.align-items-center.mb-2(v-for="(question, index) in beforeValue.questions")
        img.checkbox.mr-1(v-if="beforeValue.answer[index] == null" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="beforeValue.answer[index] == false" src="@/assets/login-checkbox-off.png")
        img.checkbox.mr-1(v-if="beforeValue.answer[index] == true" src="@/assets/login-checkbox-on.png")
        span {{ beforeValue.questions[index] }}

      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        .d-flex.flex-row.align-items-center.mb-2(v-for="(question, index) in value.questions")
          b-form-checkbox(:id="value.id + '-' + index" v-model="value.answer[index]" :name="value.id + '-' + index"
            :value="true" :unchecked-value="false") {{ value.questions[index] }}

        input(type="hidden" :id="value.id" :name="value.id" v-model="value.answer" v-validate="createValidateRules(value)" :data-vv-as="value.label")
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}

    //- type: textarea
    .template-item-textarea.d-flex.flex-column.mb-2(v-if="isTextarea(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .item-textarea
        span.warning-message(v-if="!beforeValue.answer") 未入力
        span.textarea(v-else) {{ beforeValue.answer }}
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        b-form-textarea(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :rows="value.rows"
          :no-resize="value.noResize" :minlength="value.minlength" :maxlength="value.maxlength" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
          v-validate="createValidateRules(value)" data-vv-as="本項目")
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}

    //- type: address
    .template-item-address.d-flex.flex-column.mb-2(v-if="isAddress(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .d-flex.flex-column
        .d-flex.flex-row
          span 郵便番号：
          span.warning-message(v-if="!beforeValue.answer || !beforeValue.answer.postalCode") 未入力
          span(v-else) {{ beforeValue.answer.postalCode }}
        .d-flex.flex-row
          span 住所：
          span.warning-message(v-if="!beforeValue.answer || !beforeValue.answer.address") 未入力
          span(v-else) {{ beforeValue.answer.address }}
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        .d-flex.flex-row
          b-form-input.postal-code.mb-1.mr-2(:id="value.id + '-postal-code'" v-model="value.answer.postalCode" :name="value.id + '-postal-code'"
            placeholder="郵便番号" maxlength="8" :class="[ { noinput: (isRequired(value) && !value.answer.postalCode) } ]"
            v-validate="createValidateRules(value)" data-vv-as="郵便番号")
          button.btn.search-address-btn(type="button" @click="onSearchAddress(value)") 住所検索
        .error-messages(v-for="error in errors.collect(value.id + '-postal-code')")
          .error-message {{ error }}
        span.error-message(v-show="addressErrorMessage") {{ addressErrorMessage }}
        b-form-input(:id="value.id + '-address'" v-model="value.answer.address" :name="value.id + '-address'" placeholder="住所" maxlength="100"
          :class="[ { noinput: (isRequired(value) && !value.answer.address) } ]" v-validate="createValidateRules(value)" data-vv-as="住所")
        .error-messages(v-for="error in errors.collect(value.id + '-address')")
          .error-message {{ error }}

    //- type: birthday
    .template-item-birthday.d-flex.flex-column.mb-2(v-if="isBirthday(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .d-flex.flex-row.align-items-center
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.year") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.year }}
        span.mr-2 年
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.month") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.month }}
        span.mr-2 月
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.date") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.date }}
        span.mr-2 日
        span(v-if="beforeValue.answer && beforeValue.answer.month && beforeValue.answer.date ") （{{ createAge(beforeValue) }}歳）
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        .d-flex.flex-row.align-items-center
          b-form-select.year(:id="value.id + '-year'" v-model="value.answer.year" :name="value.id + '-year'" :options="getYearOptions(value)"
            :class="[ { noinput: (isRequired(value) && !value.answer.year) } ]" v-validate="createValidateRules(value)" data-vv-as="年")
          span.ml-2.mr-2 年
          b-form-select.month(:id="value.id + '-month'" v-model="value.answer.month" :name="value.id + '-month'" :options="getMonthOptions()"
            :class="[ { noinput: (isRequired(value) && !value.answer.month) } ]" v-validate="createValidateRules(value)" data-vv-as="月")
          span.ml-2.mr-2 月
          b-form-select.date(:id="value.id + '-date'" v-model="value.answer.date" :name="value.id + '-date'" :options="getDateOptions()"
            :class="[ { noinput: (isRequired(value) && !value.answer.date) } ]" v-validate="createValidateRules(value)" data-vv-as="日")
          span.ml-2.mr-2 日
          span(v-if="value.answer && value.answer.month &&value.answer.date ") （{{ createAge(value) }}歳）
        .error-messages(v-for="error in errors.collect(value.id + '-year')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id + '-month')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id + '-date')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}

    //- type: yearMonthDate
    .template-item-year-month-date.mb-2(v-if="isYearMonthDate(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .d-flex.flex-row.align-items-center
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.year") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.year }}
        span.mr-2 年
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.month") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.month }}
        span.mr-2 月
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.date") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.date }}
        span.mr-2 日
        span.mr-2(v-if="beforeValue.suffix") {{ beforeValue.suffix }}
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        .d-flex.flex-row.align-items-center
          b-form-select.year(:id="value.id + '-year'" v-model="value.answer.year" :name="value.id + '-year'" :options="getYearOptions(value)"
            :class="[ { noinput: (isRequired(value) && !value.answer.year) } ]" v-validate="createValidateRules(value)" data-vv-as="年")
          span.ml-2.mr-2 年
          b-form-select.month(:id="value.id + '-month'" v-model="value.answer.month" :name="value.id + '-month'" :options="getMonthOptions()"
            :class="[ { noinput: (isRequired(value) && !value.answer.month) } ]" v-validate="createValidateRules(value)" data-vv-as="月")
          span.ml-2.mr-2 月
          b-form-select.date(:id="value.id + '-date'" v-model="value.answer.date" :name="value.id + '-date'" :options="getDateOptions()"
            :class="[ { noinput: (isRequired(value) && !value.answe.date) } ]" v-validate="createValidateRules(value)" data-vv-as="日")
          span.ml-2.mr-2 日
          span.ml-2(v-if="value.suffix") {{ value.suffix }}
        .error-messages(v-for="error in errors.collect(value.id + '-year')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id + '-month')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id + '-date')")
          .error-message {{ error }}

    //- type: yearMonth
    .template-item-year-month-date.mb-2(v-if="isYearMonth(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .d-flex.flex-row.align-items-center
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.year") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.year }}
        span.mr-2 年
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.month") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.month }}
        span.mr-2 月
        span.mr-2(v-if="beforeValue.suffix") {{ beforeValue.suffix }}
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        .d-flex.flex-row.align-items-center
          b-form-select.year(:id="value.id + '-year'" v-model="value.answer.year" :name="value.id + '-year'" :options="getYearOptions(value)"
            :class="[ { noinput: (isRequired(value) && !value.answer.year) } ]" v-validate="createValidateRules(value)" data-vv-as="年")
          span.ml-2.mr-2 年
          b-form-select.month(:id="value.id + '-month'" v-model="value.answer.month" :name="value.id + '-month'" :options="getMonthOptions()"
            :class="[ { noinput: (isRequired(value) && !value.answer.month) } ]" v-validate="createValidateRules(value)" data-vv-as="月")
          span.ml-2.mr-2 月
          span.ml-2(v-if="value.suffix") {{ value.suffix }}
        .error-messages(v-for="error in errors.collect(value.id + '-year')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id + '-month')")
          .error-message {{ error }}

    //- type: roomType
    .template-item-room-type.mb-2(v-if="isRoomType(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .facility-recruitment(v-for="(checkbox, index) in beforeValue.answer")
        template(v-if="showRecruitement(beforeValue.answer[index])")
          span.facility-name ・{{ getFacilityName(beforeValue.answer[index]) }}
          .checkboxs.ml-3
            .checkbox(v-if="beforeValue.answer[index].recruitmentRoom.multiBed") 従来型多床室
            .checkbox(v-if="beforeValue.answer[index].recruitmentRoom.conventinalSingle") 従来型個室
            .checkbox(v-if="beforeValue.answer[index].recruitmentRoom.unitTypeSingle") ユニット型個室
            .checkbox(v-if="beforeValue.answer[index].recruitmentRoom.single") 個室
            .checkbox(v-if="beforeValue.answer[index].recruitmentRoom.double") ２人部屋（夫婦部屋）
          .checkboxs.ml-3
            .checkbox(v-if="beforeValue.answer[index].customRecruitmentRoom && 0 < beforeValue.answer[index].customRecruitmentRoom.length && room.use"
              v-for="room in beforeValue.answer[index].customRecruitmentRoom") {{ room.name }}
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        .facility-recruitment(v-for="(checkbox, index) in value.answer")
          span.facility-name ・{{ getFacilityName(value.answer[index]) }}
          .checkboxs.ml-3
            b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'multiBed')" :id="value.id + '-' + checkbox.facilityId + '-multiBed'"
              v-model="value.answer[index].recruitmentRoom.multiBed" :value="true" :unchecked-value="false") 従来型多床室
            b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'conventinalSingle')" :id="value.id + '-' + checkbox.facilityId + '-conventinalSingle'"
              v-model="value.answer[index].recruitmentRoom.conventinalSingle" :value="true" :unchecked-value="false") 従来型個室
            b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'unitTypeSingle')" :id="value.id + '-' + checkbox.facilityId + '-unitTypeSingle'"
              v-model="value.answer[index].recruitmentRoom.unitTypeSingle" :value="true" :unchecked-value="false") ユニット型個室
            b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'single')" :id="value.id + '-' + checkbox.facilityId + '-single'"
              v-model="value.answer[index].recruitmentRoom.single" :value="true" :unchecked-value="false") 個室
            b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'double')" :id="value.id + '-' + checkbox.facilityId + '-double'"
              v-model="value.answer[index].recruitmentRoom.double" :value="true" :unchecked-value="false") ２人部屋（夫婦部屋）
          .checkboxs.ml-3(v-if="value.answer[index].customRecruitmentRoom && 0 < value.answer[index].customRecruitmentRoom.length")
            b-form-checkbox(v-if="showCustomRecruitmentRoom(value.answer[index], room)"
              v-for="(room, roomIndex) in value.answer[index].customRecruitmentRoom"
              :id="value.id + '-' + checkbox.facilityId + '-' + room.id"
              v-model="value.answer[index].customRecruitmentRoom[roomIndex].use" :value="true" :unchecked-value="false") {{ room.name }}
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}

    //- type: file
    .template-item-file.mb-2(v-if="isFile(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
        span.error-message(v-show="fileErrorMesage") {{ fileErrorMesage }}
      //- before value
      span.warning-message(v-if="!beforeValue.answer || beforeValue.answer.length == 0") 未入力
      template(v-else v-for="(file, index) in beforeValue.answer")
        .d-flex.flex-row.align-items-center
          span.mr-2 {{ file.name }}
          button.btn.file-preview-btn(@click="onFilePreview(beforeValue, index)") プレビュー
        .mb-2
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)" v-for="(file, index) in value.tempAnswer")
        .d-flex.flex-row.align-items-center
          FileSelecter.mr-2(:id="value.id + '-' + index" v-model="value.tempAnswer[index]" :mimetype="createFileAccept(value)" :showDragAndDrop="false"
            :file-name="file && file.file ? file.file.name : ''" height="28px" :disableDeleteButton="disableFileDeleteButton(value)"
            @on-delete="onDeleteFile(value, index)")
          //- input(v-if="value.tempAnswer" v-model="value.tempAnswer.file" :name="value.id" v-validate="createValidateRules(value)" data-vv-as="本項目" type="hidden")
          input(v-if="file" v-model="value.tempAnswer[index].file" :name="value.id + '-' + index" v-validate="createValidateRules(value)" data-vv-as="本項目" type="hidden")

          button.btn.file-preview-btn(@click="onFilePreview(value, index)"
            :class="{ 'disable': disableFilePreviewButton(value, index) }" :disabled="disableFilePreviewButton(value, index)") プレビュー
        .error-messages(v-for="error in errors.collect(value.id)")
          .error-message {{ error }}
        .mb-2
      button.btn.add-file-btn(v-if="showAfterValue(value, beforeValue)" @click="onAddFile(value)" :class="{ 'disable': disableAddFileButton(value) }"
        :disabled="disableAddFileButton(value)") ファイルを追加

      PdfModal(v-model="showPdfModal" :pdfUrl="pdfModalUrl")
      ImageModal(v-model="showImageModal" :imageUrl="imageModalUrl")

    //- type: tel
    .template-item.d-flex.flex-column.mb-2(v-if="isTel(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .d-flex.flex-row.align-items-center
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.first") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.first }}
        span.mr-2 －
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.second") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.second }}
        span.mr-2 －
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.third") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.third }}
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        .d-flex.flex-row.align-items-center
          b-form-input.tel-input(:id="value.id + '-first'" v-model="value.answer.first" :name="value.id + '-first'" 
            :minlength="3" :maxlength="4" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
            v-validate="createValidateRules(value)" data-vv-as="電話番号１")
          span.ml-2.mr-2 －
          b-form-input.tel-input(:id="value.id + '-second'" v-model="value.answer.second" :name="value.id + '-second'" 
            :minlength="3" :maxlength="4" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
            v-validate="createValidateRules(value)" data-vv-as="電話番号２")
          span.ml-2.mr-2 －
          b-form-input.tel-input(:id="value.id + '-third'" v-model="value.answer.third" :name="value.id + '-third'" 
            :minlength="3" :maxlength="4" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
            v-validate="createValidateRules(value)" data-vv-as="電話番号３")
        .error-messages(v-for="error in errors.collect(value.id + '-first')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id + '-second')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id + '-third')")
          .error-message {{ error }}

    //- type: name
    .template-item-name.d-flex.flex-column.mb-2(v-if="isName(beforeValue)")
      //- lebels
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="beforeValue.label && beforeValue.showLabel") {{ beforeValue.label }}
        span.validation-label.mr-1(v-if="isRequired(beforeValue)") 必須
        span.facility-only-label.mr-1(v-if="beforeValue.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="beforeValue.text") {{ beforeValue.text }}
        .text.warning-message(v-if="beforeValue.strongText") {{ beforeValue.strongText }}
      //- before value
      .d-flex.flex-row.align-items-center
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.secondName") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.secondName }}
        span.warning-message(v-if="!beforeValue.answer || !beforeValue.answer.firstName") 未入力
        span(v-else) {{ beforeValue.answer.firstName }}
        span （
        span.warning-message.mr-2(v-if="!beforeValue.answer || !beforeValue.answer.secondKanaName") 未入力
        span.mr-2(v-else) {{ beforeValue.answer.secondKanaName }}
        span.warning-message(v-if="!beforeValue.answer || !beforeValue.answer.firstKanaName") 未入力
        span(v-else) {{ beforeValue.answer.firstKanaName }}
        span ）
      //- arrow
      .diff-arrow.mt-1.mb-1(v-if="showAfterValue(value, beforeValue)")
        .arrow-down-icon
      //- after value
      template(v-if="showAfterValue(value, beforeValue)")
        .d-flex.flex-row.align-items-center.mb-1
          span.template-item-name-sub-label.mr-2 姓
          b-form-input.name-input.mr-4(:id="value.id + '-second'" v-model="value.answer.secondName" :name="value.id + '-second'" :placeholder="'姓'"
            :maxlength="15" :class="[ { noinput: !value.answer.secondName } ]" v-validate="createValidateRules(value)" data-vv-as="姓")
          span.template-item-name-sub-label.mr-2 名
          b-form-input.name-input(:id="value.id + '-first'" v-model="value.answer.firstName" :name="value.id + '-first'" :placeholder="'名'"
            :maxlength="15" :class="[ { noinput: !value.answer.firstName } ]" v-validate="createValidateRules(value)" data-vv-as="名")
        .d-flex.flex-row.align-items-center
          span.template-item-name-sub-label.mr-2 せい
          b-form-input.name-input.mr-4(:id="value.id + '-second-kana'" v-model="value.answer.secondKanaName" :name="value.id + '-second-kana'" :placeholder="'せい'"
            :maxlength="15" :class="[ { noinput: !value.answer.secondKanaName } ]" v-validate="createValidateRules(value, { 'hiraganaAndNumbers': true })" data-vv-as="せい")
          span.template-item-name-sub-label.mr-2 めい
          b-form-input.name-input(:id="value.id + '-first-kana'" v-model="value.answer.firstKanaName" :name="value.id + '-first-kana'" :placeholder="'めい'"
            :maxlength="15" :class="[ { noinput: !value.answer.firstKanaName } ]" v-validate="createValidateRules(value, { 'hiraganaAndNumbers': true })" data-vv-as="めい")
        .error-messages(v-for="error in errors.collect(value.id + '-second')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id + '-first')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id + '-second-kana')")
          .error-message {{ error }}
        .error-messages(v-for="error in errors.collect(value.id + '-first-kana')")
          .error-message {{ error }}
          
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { userStore } from "@/store/store";
import Setting from "../../../../public/setting.json";

import {
  TemplateItem,
  TemplateType,
  TemplateItemAddress,
  TemplateItemBirthday,
  TemplateItemYearMonthDate,
  TemplateItemFile,
  TemplateItemInput,
  TemplateItemGroup,
  TemplateItemText,
  RoomType,
  TemplateItemRadio,
  TemplateItemCheckbox,
  TemplateItemRoomType,
  SelectOption,
  TemplateItemMultipleCheckbox
} from "@/commons/services/AdmissionApplicationTemplates";
import { CustomRecruitmentRoom, FacilityGetModel } from "@/commons/services/Facilities";
import S3UrlService from "@/commons/services/S3Url";
import ZipcloudService, { ZipcloudGetModel } from "@/commons/services/Zipcloud";
import FileReaderWrapper from "@/commons/utils/FileReaderWrapper";

import PageLoading from "@/pc/basics/PageLoading.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import PdfModal from "@/pc/basics/PdfModal.vue";
import ImageModal from "@/pc/basics/ImageModal.vue";
import ChildTemplateItem from "@/pc/containers/waiters/WaiterTemplateDiffInputItem.vue";
import FileSelecter from "@/pc/basics/FileSelecter.vue";

/**
 * ### 待機者登録画面コンポーネント
 */
@Component({
  components: {
    PageLoading,
    HelpIcon,
    PdfModal,
    ImageModal,
    ChildTemplateItem,
    FileSelecter
  },
  // 再帰呼び出しする場合、proビルド時にコンポーネント名が書き換えられて動かなくなるので明示的に定義する
  name: "WaiterTemplateDiffInputItem"
})
export default class WaiterTemplateDiffInputItem extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;
  /** zipcloudサービス */
  @Inject("ZipcloudService") zipcloudService!: ZipcloudService;

  /** テンプレート情報 */
  @Prop({ required: true })
  value!: TemplateItem;

  @Prop({ required: true })
  beforeValue!: TemplateItem;

  /** 閲覧可能施設 */
  @Prop({ required: true })
  waiterViewableFacilitiesMap!: Map<number, FacilityGetModel>;

  /** 子要素かどうか */
  @Prop({ required: true })
  isChaild!: boolean;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** type:address のエラーメッセージ */
  addressErrorMessage: string = "";

  /** type:file のPDFプレビューモーダル表示可否 */
  showPdfModal: boolean = false;
  /** type:file のPDFプレビューモーダルで表示する対象のURL */
  pdfModalUrl: string = "";
  /** type:file の画像プレビューモーダル表示可否 */
  showImageModal: boolean = false;
  /** type:file の画像プレビューモーダルで表示する対象のURL */
  imageModalUrl: string = "";
  /** type:file のエラーメッセージ */
  fileErrorMesage: string = "";

  get _margin(): string[] {
    if (this.isChaild == true) {
      return ["mr-3", "mb-3", "ml-3"];
    } else {
      return [""];
    }
  }

  public showAfterValue(before: TemplateItem, after: TemplateItem): boolean {
    switch (before.type) {
      case TemplateType.TEXT:
      case TemplateType.RADIO:
      case TemplateType.RADIO_GROUP:
      case TemplateType.SELECT:
      case TemplateType.TEXTAREA:
      case TemplateType.ADDRESS:
      case TemplateType.BIRTHDAY:
      case TemplateType.YEAR_MONTH_DATE:
      case TemplateType.YEAR_MONTH:
      case TemplateType.TEL:
      case TemplateType.NAME: {
        const beforeItem: { answer: any } = before as any;
        const afterItem: { answer: any } = after as any;
        const beforeAnswer: string = JSON.stringify(beforeItem.answer);
        const afterAnswer: string = JSON.stringify(afterItem.answer);
        return beforeAnswer == afterAnswer ? false : true;
      }
      case TemplateType.CHECKBOX:
      case TemplateType.SWITCH_CHECKBOX: {
        // 初期値がNULLの場合があるので、before：nullでかつafter：falseなら変更していない扱いにする
        const beforeItem: TemplateItemCheckbox = before as TemplateItemCheckbox;
        const afterItem: TemplateItemCheckbox = after as TemplateItemCheckbox;
        const beforeAnswer: boolean = beforeItem.answer ? beforeItem.answer : false;
        const afterAnswer: boolean = afterItem.answer ? afterItem.answer : false;
        return beforeAnswer == afterAnswer ? false : true;
      }
      case TemplateType.MULTIPLE_CHECKBOX: {
        // 初期値がNULLの場合があるので、answerのnullはfalseに置き換える
        const beforeItem: TemplateItemMultipleCheckbox = before as TemplateItemMultipleCheckbox;
        const beforeAnswers = [];
        for (const beforeAnswer of beforeItem.answer) {
          beforeAnswers.push(beforeAnswer == true ? true : false);
        }
        const afterItem: TemplateItemMultipleCheckbox = after as TemplateItemMultipleCheckbox;
        const afterAnswers = [];
        for (const afterAnswer of afterItem.answer) {
          afterAnswers.push(afterAnswer == true ? true : false);
        }

        const beforeAnswer: string = JSON.stringify(beforeAnswers);
        const afterAnswer: string = JSON.stringify(afterAnswers);
        return beforeAnswer == afterAnswer ? false : true;
      }
      case TemplateType.FILE: {
        const beforeFileItem: TemplateItemFile = before as TemplateItemFile;
        const afterFileItem: TemplateItemFile = after as TemplateItemFile;
        // botの仕様で、空配列ではなくnullが格納されてしまう問題があるので、置き換えをする
        if (beforeFileItem.answer == null) {
          beforeFileItem.answer = [];
        }
        if (afterFileItem.answer == null) {
          afterFileItem.answer = [];
        }
        // ファイル数が変わっていれば変更している扱い
        if (beforeFileItem.answer.length != afterFileItem.answer.length) {
          return true;
        }

        const beforeFileNames: string[] = [];
        const afterFileNames: string[] = [];
        for (let i = 0; i < beforeFileItem.answer.length; i++) {
          beforeFileNames.push(beforeFileItem.answer[i]!.name);
          afterFileNames.push(afterFileItem.answer[i]!.name);
        }
        const beforeAnswer: string = JSON.stringify(beforeFileNames);
        const afterAnswer: string = JSON.stringify(afterFileNames);
        return beforeAnswer == afterAnswer ? false : true;
      }
      case TemplateType.ROOM_TYPE: {
        const beforeItem: TemplateItemRoomType = before as TemplateItemRoomType;
        const afterItem: TemplateItemRoomType = after as TemplateItemRoomType;
        // answerの配列順は入れ替わることがあるので、facilityId昇順にソートしてから比較する
        const sortedBeforeAnswer: Array<RoomType> = beforeItem.answer.concat().sort((a, b) => a.facilityId - b.facilityId);
        const sortedAfterAnswer: Array<RoomType> = afterItem.answer.concat().sort((a, b) => a.facilityId - b.facilityId);
        const beforeAnswer: string = JSON.stringify(sortedBeforeAnswer);
        const afterAnswer: string = JSON.stringify(sortedAfterAnswer);
        return beforeAnswer == afterAnswer ? false : true;
      }
      default: {
        return false;
      }
    }
  }

  public isSection(item: TemplateItem): boolean {
    if (item.type != TemplateType.SECTION) {
      return false;
    }
    return true;
  }

  public isGroup(item: TemplateItem): boolean {
    if (item.type != TemplateType.GROUP) {
      return false;
    }
    return true;
  }

  /**
   * ### グループの変更前値のpropertiesを返す
   *
   * - 変更前値と変更後値でpropertiesの数が異なる場合があるので調整する必要がある
   *   - 変更前値が多い場合(削除によるproperties減の場合)
   *     - TODO(現在はbot側の変更申請でGROUPの要素の「削除」が出来ないので保留)
   *   - 変更前後が多い場合(追加によるproperties増の場合)
   *     - 変更前値に初期化したpropertyを追加して画面表示させる
   * - 変更前値を直接変更すると経過記録登録時に正しい値がDBに登録されないためdeepcopyしたものをproperties調整して返す
   */
  public getBeforePropertiesOfGroup(beforeValue: TemplateItemGroup, afterValue: TemplateItemGroup): Array<Array<TemplateItem>> {
    let beforeValueClone: TemplateItemGroup = JSON.parse(JSON.stringify(beforeValue));
    let afterValueClone: TemplateItemGroup = JSON.parse(JSON.stringify(afterValue));

    if (afterValueClone.properties.length < beforeValueClone.properties.length) {
      // TODO 削除等で更新後値の方がproperties要素が少ない場合の挙動について相談が必要
    } else if (beforeValueClone.properties.length < afterValueClone.properties.length) {
      const endIndex: number = afterValueClone.properties.length - beforeValueClone.properties.length;
      for (let i = 0; i < endIndex; i++) {
        this.onAddGroupItem(beforeValueClone);
      }
    }

    return beforeValueClone.properties;
  }

  public onDeleteGroupItem(item: TemplateItemGroup, index: number): void {
    item.properties.splice(index, 1);

    // idの採番し直し
    for (let i = 0; i < item.properties.length; i++) {
      for (let j = 0; j < item.properties[i].length; j++) {
        const id: string = item.template[i].id;
        item.properties[i][j].id = `${id}${i}`;
      }
    }

    return;
  }

  public disableAddGroupItemButton(item: TemplateItemGroup): boolean {
    if (item.displayAddButton && !item.max) {
      console.error("template format error. type:group displayAddButton=true but max=undefined");
      return true;
    }
    if (item.max && item.properties.length < item.max) {
      return false;
    }

    return true;
  }

  public onAddGroupItem(item: TemplateItemGroup): void {
    let templateClone: Array<TemplateItem> = JSON.parse(JSON.stringify(item.template));

    const suffix: number = item.properties.length;
    for (const cloneItem of templateClone) {
      cloneItem.id = `${cloneItem.id}${suffix}`;
    }
    item.properties.push(templateClone);

    return;
  }

  public isText(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEXT) {
      return false;
    }
    return true;
  }

  public getTextStyle(item: TemplateItemText): string {
    if (!item.width) {
      return "";
    }
    return `width:${item.width}px;`;
  }

  public createValidateRules(item: TemplateItem, addValidationNames?: { [key: string]: number | boolean }): any {
    let rules: any = {};

    // itemの保持するルールをオブジェクト化する
    const inputItem: TemplateItemInput = item as TemplateItemInput;

    if (inputItem.validationRules == null) {
      return rules;
    }

    for (const rule of inputItem.validationRules) {
      const splitedRule: string[] = rule.split(":");
      if (splitedRule.length == 1) {
        rules[`${splitedRule[0]}`] = true;
      } else {
        rules[`${splitedRule[0]}`] = splitedRule[1];
      }
    }

    // 追加用のバリデーションルールがあれば追加する
    if (addValidationNames) {
      for (const key in addValidationNames) {
        if (Object.prototype.hasOwnProperty.call(addValidationNames, key)) {
          // addValidationNames のプロパティを rules にコピー
          // 既存のルールでも上書きする
          rules[key] = addValidationNames[key];
        }
      }
    }

    // ファイル種別毎のルールを追加する
    switch (item.type) {
      case TemplateType.TEXT:
      case TemplateType.RADIO:
      case TemplateType.RADIO_GROUP:
      case TemplateType.SELECT:
      case TemplateType.CHECKBOX:
      case TemplateType.TEXTAREA:
      case TemplateType.ADDRESS:
      case TemplateType.BIRTHDAY:
      case TemplateType.YEAR_MONTH:
      case TemplateType.YEAR_MONTH_DATE:
      case TemplateType.ROOM_TYPE: {
        break;
      }
      case TemplateType.FILE: {
        // TODO #3645の対応でvalidationが動かなくなってしまったのでコメントアウト
        // 自前でバリデーションするしかない
        // rules["file_size"] = 10; // 10MB制限を追加する
        break;
      }
      case TemplateType.TEL: {
        rules["max"] = 4;
        rules["custom_numeric"] = true;
        break;
      }
      case TemplateType.NAME: {
        rules["max"] = 15;
        break;
      }
      case TemplateType.MULTIPLE_CHECKBOX: {
        // requiredが格納されている場合、配列内に1つ以上のtrueを指すので「atLeastOneTrue」に置き換える
        if (rules["required"] == true) {
          rules["atLeastOneTrue"] = true;
          delete rules["required"];
        }
        break;
      }
      default: {
        return {};
      }
    }
    return rules;
  }

  public isRadio(item: TemplateItem): boolean {
    if (item.type != TemplateType.RADIO) {
      return false;
    }
    return true;
  }

  public getRadioText(item: TemplateItemRadio): string {
    if (item == null) {
      return "";
    }

    for (const option of item.options) {
      if (option.value == item.answer) {
        return option.text;
      }
    }

    return "";
  }

  public isRadioGroup(item: TemplateItem): boolean {
    if (item.type != TemplateType.RADIO_GROUP) {
      return false;
    }
    return true;
  }

  public isSelect(item: TemplateItem): boolean {
    if (item.type != TemplateType.SELECT) {
      return false;
    }
    return true;
  }

  public createSelectOptions(sourceOptions: Array<SelectOption>): Array<SelectOption> {
    const options: Array<SelectOption> = [];

    let existNullOption: boolean = false;
    for (const sourceOption of sourceOptions) {
      if (sourceOption.value == null) {
        existNullOption = true;
      }
    }
    if (existNullOption == false) {
      options.push({ text: "", value: null as any });
    }
    return options.concat(sourceOptions);
  }

  public isCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.CHECKBOX) {
      return false;
    }
    return true;
  }

  public isSwitchCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.SWITCH_CHECKBOX) {
      return false;
    }
    return true;
  }

  public isMultipleCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.MULTIPLE_CHECKBOX) {
      return false;
    }
    return true;
  }

  public isTextarea(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEXTAREA) {
      return false;
    }
    return true;
  }

  public isAddress(item: TemplateItem): boolean {
    if (item.type != TemplateType.ADDRESS) {
      return false;
    }
    return true;
  }

  public async onSearchAddress(item: TemplateItemAddress): Promise<void> {
    if (!item.answer.postalCode) {
      return;
    }

    const address: ZipcloudGetModel = await this.zipcloudService.get(item.answer.postalCode);
    if (!address.results) {
      this.addressErrorMessage = "郵便番号から住所が取得できませんでした。手動で入力してください。";
      return;
    } else {
      this.addressErrorMessage = "";
      item.answer.address = `${address.results[0].address1}${address.results[0].address2}${address.results[0].address3}`;
    }

    return;
  }

  public isBirthday(item: TemplateItem): boolean {
    if (item.type != TemplateType.BIRTHDAY) {
      return false;
    }
    return true;
  }

  public getYearOptions(item: TemplateItemBirthday | TemplateItemYearMonthDate): Array<{ text: string; value: string | null }> {
    const options: Array<{ text: string; value: string | null }> = [{ text: "", value: null }]; // 初期値にリセット用の選択肢を用意しておく

    const currentYear: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyy");
    const startPosition: number = currentYear - item.startYearRange;
    const count: number = item.startYearRange + item.endYearRange;

    for (let i = 0; i <= count; i++) {
      const year: number = startPosition + i;
      const date = new Date(year, 11, 31, 0, 0);
      const intlOptions: Intl.DateTimeFormatOptions = { year: "numeric" };
      const jpYear: string = new Intl.DateTimeFormat("ja-JP-u-ca-japanese", intlOptions).format(date).slice(0, -1); // 年が重複するので最終文字だけ削除;

      options.push({
        text: `${year}（${jpYear}）`,
        value: `${year}`
      });
    }

    return options;
  }

  public getMonthOptions(): Array<{ text: string; value: string | null }> {
    const options: Array<{ text: string; value: string | null }> = [{ text: "", value: null }]; // 初期値にリセット用の選択肢を用意しておく

    for (let i = 1; i <= 12; i++) {
      options.push({
        text: `${i}`,
        value: `${i}`
      });
    }

    return options;
  }

  public getDateOptions(): Array<{ text: string; value: string | null }> {
    const options: Array<{ text: string; value: string | null }> = [{ text: "", value: null }]; // 初期値にリセット用の選択肢を用意しておく

    for (let i = 1; i <= 31; i++) {
      options.push({
        text: `${i}`,
        value: `${i}`
      });
    }

    return options;
  }

  public createAge(item: TemplateItemBirthday): number {
    const age: number = this.$dateUtil.convertBirthdayToAge(Number(item.answer.year), Number(item.answer.month), Number(item.answer.date));
    return age;
  }

  public isYearMonthDate(item: TemplateItem): boolean {
    if (item.type != TemplateType.YEAR_MONTH_DATE) {
      return false;
    }
    return true;
  }

  public isYearMonth(item: TemplateItem): boolean {
    if (item.type != TemplateType.YEAR_MONTH) {
      return false;
    }
    return true;
  }

  public isRoomType(item: TemplateItem): boolean {
    if (item.type != TemplateType.ROOM_TYPE) {
      return false;
    }
    return true;
  }

  public showRecruitement(roomType: RoomType): boolean {
    return (
      roomType.recruitmentRoom.multiBed ||
      roomType.recruitmentRoom.conventinalSingle ||
      roomType.recruitmentRoom.unitTypeSingle ||
      roomType.recruitmentRoom.double ||
      roomType.recruitmentRoom.single
    );
  }

  public showRecruitmentRoom(roomType: RoomType, roomTypeName: string): boolean {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

    if (!facility) {
      return false;
    }
    const recruitmentRoom: any = facility.recruitmentRoom;

    return recruitmentRoom[roomTypeName];
  }

  public showCustomRecruitmentRoom(roomType: RoomType, room: CustomRecruitmentRoom): boolean {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

    if (!facility || !facility.customRecruitmentRoom || facility.customRecruitmentRoom.length <= 0) {
      return false;
    }
    for (const customRoom of facility.customRecruitmentRoom) {
      if (customRoom.id == room.id) {
        return customRoom.use;
      }
    }

    return false;
  }

  public getFacilityName(roomType: RoomType): string {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

    if (!facility) {
      return "";
    }

    return facility.name;
  }

  public isFile(item: TemplateItem): boolean {
    if (item.type != TemplateType.FILE) {
      return false;
    }
    return true;
  }

  public createFileAccept(item: TemplateItemFile): string {
    if (!item.accept) {
      return "";
    }
    return item.accept.join(", ");
  }

  public isTel(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEL) {
      return false;
    }
    return true;
  }

  public isName(item: TemplateItem): boolean {
    if (item.type != TemplateType.NAME) {
      return false;
    }
    return true;
  }

  public isRequired(item: TemplateItemInput): boolean {
    if (item.validationRules == null) {
      return false;
    }

    for (const validationRule of item.validationRules) {
      if (validationRule == "required") {
        return true;
      }
    }
    return false;
  }

  public onDeleteFile(item: TemplateItemFile, index: number): void {
    if (item.tempAnswer == null) {
      item.tempAnswer = [];
    }
    if (item.answer == null) {
      item.answer = [];
    }

    if (item.tempAnswer.length <= 1) {
      item.tempAnswer[index] = {
        file: null as any,
        fileName: ""
      };
      item.answer[index] = {
        name: "",
        url: ""
      };
    } else {
      item.tempAnswer.splice(index, 1);
      if (item.answer == null) {
        item.answer = [];
      }
      item.answer.splice(index, 1);
    }
    this.$forceUpdate(); // 再描画しないとFileSelecterコンポーネントが再描画されない
    return;
  }

  public async onFilePreview(item: TemplateItemFile, index: number): Promise<void> {
    if (item.tempAnswer == null || !item.answer) {
      return;
    }
    if (!item.tempAnswer[index] && !item.answer[index]) {
      this.fileErrorMesage = "プレビュー非対応のファイル種別のため表示できません。";
      return;
    }

    // DBのデータ不正でtempAnswerにデータがあるが、正しいデータ形式ではない（fileNameまたはfileが無い）場合はtempAnswerをリセットする
    if (item.tempAnswer) {
      let isError = false;
      if (!item.tempAnswer[index].file || !item.tempAnswer[index].fileName || item.tempAnswer[index].file instanceof File == false) {
        isError = true;
      }
      // ここでtempAnswerをnullにすると画面上で一度ファイルが消えたように見えるので、ここでtempAnswerを作り直す
      if (isError && item.answer[index]) {
        this.isBusy = true;
        this.loadingMessage = "読込み中...";

        // S3からファイルを取得しなおす
        const s3File: File = await this.getS3File(item.answer[index].url, item.answer[index].name);
        item.tempAnswer[index] = {
          file: s3File,
          fileName: s3File.name
        };

        this.isBusy = false;
      }
    }

    switch (item.tempAnswer[index].file.type) {
      case "image/jpeg":
      case "image/png": {
        const url: string = await FileReaderWrapper.readAsDataURL(item.tempAnswer[index].file);
        this.imageModalUrl = url;
        this.showImageModal = true;
        break;
      }
      case "application/pdf": {
        const url: string = window.URL.createObjectURL(item.tempAnswer[index].file);
        this.pdfModalUrl = url;
        this.showPdfModal = true;
        break;
      }
      default: {
        this.fileErrorMesage = "プレビュー非対応のファイル種別のため表示できません。";
        break;
      }
    }

    return;
  }

  /**
   * ### S3に格納されているFileを取得する
   *
   * @param url 元URL
   */
  private async getS3File(url: string, fileName: string): Promise<File> {
    const response: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, url, fileName);
    return response;
  }

  public disableFileDeleteButton(item: TemplateItemFile): boolean {
    if (item.tempAnswer == null) {
      return true;
    }

    if (item.tempAnswer.length <= 1 && (item.tempAnswer[0] == null || item.tempAnswer[0].file == null)) {
      return true;
    } else {
      return false;
    }
  }

  public disableFilePreviewButton(item: TemplateItemFile, index: number): boolean {
    if (item.tempAnswer == null) {
      return true;
    }

    if (item.tempAnswer[index] && item.tempAnswer[index].file) {
      return false;
    }
    return true;
  }

  public onAddFile(item: TemplateItemFile): void {
    if (item.tempAnswer == null) {
      return;
    }

    if (item.tempAnswer.length <= item.maxlength) {
      item.answer!.push({
        name: "",
        url: ""
      });
      item.tempAnswer.push({
        file: null as any,
        fileName: ""
      });
    }
    this.$forceUpdate(); // 再描画しないとFileSelecterコンポーネントが再描画されない
    return;
  }

  public disableAddFileButton(item: TemplateItemFile): boolean {
    if (item.tempAnswer == null) {
      return false;
    }

    if (item.maxlength <= item.tempAnswer.length) {
      return true;
    } else {
      let existNullFile: boolean = false;
      for (const file of item.tempAnswer) {
        if (file.file == null) {
          existNullFile = true;
          break;
        } else if (!file.fileName) {
          existNullFile = true;
          break;
        }
      }
      if (existNullFile) {
        return true;
      }

      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.template-diff-input-item-component {
  .section-label,
  .item-label {
    font-weight: bold;
  }

  .section-text,
  .text {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .template-group-item {
    .group-item {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }

    .group-delete-btn,
    .group-add-btn {
      font-size: 16px !important;
      height: 38px !important;
    }
  }

  .facility-only {
    background-color: rgba(245, 245, 245, 1);
    padding: 8px;
  }
  .facility-only-label {
    color: rgba(138, 138, 138, 1);
    font-size: 10px;
    border: 1px solid rgba(138, 138, 138, 1);
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
  .diff-arrow {
    .arrow-down-icon {
      @include svg-icon("../../../assets/arrow-down.svg", $validation-label-font-color, 20px, 20px);
    }
  }
  .diff-border {
    border: 1px solid $font-strong-color;
    padding: 4px !important;
  }
  .validation-label {
    color: $validation-label-font-color;
    font-size: 10px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
  .noinput {
    background-color: $bg-require-input !important;
    &::placeholder {
      color: rgb(117, 117, 117);
    }
  }

  .template-item-radio-group {
    .radio-properties {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }
  }

  .template-item-checkbox,
  .template-item-switch-checkbox {
    .checkbox {
      width: 24px;
      height: 24px;
    }
  }

  .template-item-textarea {
    .item-textarea {
      .textarea {
        white-space: pre-wrap;
        word-wrap: break-word;
      }
    }
  }

  .template-item-address {
    .postal-code {
      width: 160px;
    }
    .search-address-btn {
      font-size: 16px !important;
      width: 100px !important;
      height: 38px !important;
    }
  }

  .template-item-birthday,
  .template-item-year-month-date {
    .year {
      width: 180px;
    }
    .month {
      width: 70px;
    }
    .date {
      width: 70px;
    }
  }

  .template-item-room-type {
    .facility-name {
      font-weight: bold;
    }
  }

  .template-item-file {
    // ファイル選択のボタンを他のボタンと同じデザインに変更する
    .template-file {
      ::after {
        background-color: $btn !important;
        color: $btn-font !important;
        height: 38px !important;

        &:hover,
        &:focus {
          background-color: $btn-hover !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        &.disable {
          background-color: $btn-disable !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        &:active {
          background-color: $btn-hover !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        // .setlectedと組み合わせた場合のボタン色を指定する
        &.selected {
          background-color: $btn-selected !important;
          color: $btn-font-selected !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        // .disableと組み合わせた場合のボタン色を指定する
        &.disable {
          cursor: not-allowed;
          background-color: $btn-disable !important;
          color: $btn-font-disable !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
      }
    }
    .file-preview-btn {
      font-size: 14px !important;
      width: 130px;
      height: 32px !important;
    }
    .add-file-btn {
      font-size: 14px !important;
      min-width: 124px;
      margin: 0;
      height: 32px !important;
      padding: 4px 4px !important;
    }
  }

  .template-item-tel {
    .tel-input {
      width: 80px;
    }
  }

  .template-item-name {
    .template-item-name-sub-label {
      width: 2rem;
    }
    .name-input {
      width: 300px;
    }
  }
}
</style>
